import emptyPessoa from './emptyPessoa'
import _ from 'lodash'

export default {
  id: null,
  usuario: {
    id: null
  },
  modalidadeCadastro: null,
  tipo: {
    codigo: 'PRATICAS_SUSTENTAVEIS'
  },
  json: {
    cadastrante: {
      id: null,
      pessoa: _.cloneDeep(emptyPessoa)
    },
    proprietario: {
      id: null,
      pessoa: _.cloneDeep(emptyPessoa),
      conjuge: _.cloneDeep(emptyPessoa)
    },
    imovel: {
      id: null,
      documentos: [],
      nome: null,
      possuiCar: null,
      numerosRecibosCar: [],
      geoJson: [],
      area: null,
      registroImovel: {
        situacao: null,
        proprietarioImovel: {
          numeroMatricula: null
        },
        posseiro: {
          tipoPosse: null,
          detalhePosse: null
        },
        assentamentoReforma: {
          nomeProjeto: null,
          documento: null,
          especificacaoDocumento: null
        },
        quilombola: {
          nomeQuilombo: null,
          documento: null,
          especificacaoDocumento: null
        },
        indigena: {
          terra: null,
          aldeia: null,
          povo: null
        },
        especificacaoOutros: null
      },
      endereco: {
        bairro: '',
        cep: '',
        complemento: '',
        logradouro: '',
        municipio: {
          id: null,
          nome: '',
          codigoEstado: ''
        },
        comunidadeLocalidade: '',
        referencia: '',
        numero: '',
        semNumero: false,
        uf: ''
      }
    },
    usoSolo: {
      id: null,
      possuiReservaLegal: null,
      hasFornecedoras: null,
      destinacoesImovel: [],
      empresasFornecedoras: [],
      outrasEmpresasFornecedoras: '',
      destinacaoProducao: ''
    },
    praticas: {},
    fotos: []
  }
}



// WEBPACK FOOTER //
// ./src/libs/models/cadastro/emptyPraticas.js